export default __webpack_public_path__ + "media/images/svg/facebook-social-031a680d98951d49f7b68b2bffbb0970.svg";